const REQUIRED_PARAM_KEYS = ['pid', 'clickid'] as const;
const REQUIRED_PARAM_PREFIXES = ['af_', 'att_'] as const;

function normalizeSearch(search?: string | null): string {
  if (!search) {
    return '';
  }
  return search.startsWith('?') ? search.slice(1) : search;
}

export function hasRequiredCampaignParams(search: string | URLSearchParams): boolean {
  const searchParams = typeof search === 'string' ? new URLSearchParams(normalizeSearch(search)) : search;

  const hasRequiredKeys = REQUIRED_PARAM_KEYS.every((key) => {
    return Boolean(searchParams.get(key)?.trim());
  });

  const hasRequiredPrefixes = REQUIRED_PARAM_PREFIXES.every((prefix) => {
    for (const [key, value] of searchParams.entries()) {
      if (key.startsWith(prefix) && value.trim()) {
        return true;
      }
    }

    return false;
  });

  return hasRequiredKeys && hasRequiredPrefixes;
}
